<template>
  <b-row>
    <b-col lg="12">
      <b-card header-tag="header" style="height:950px">
        <iframe
          ref="myIframe"
          :src="`https://sunnah.omg.com.eg/files/public/#/${user.email}`"
          frameborder="0"
          style="width: 100%; height: 900px"
        ></iframe>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VueContext from "vue-context";
import Auth from '@/Apis/Auth';

export default {
  components: {
    VueContext,
    // eslint-disable-next-line vue/no-unused-components
  },
  data() {
    return {
      user:Auth.USER,
    };
  },
  methods: {
    optionClicked(text, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `You have click on ${text}!`,
          icon,
        },
      });
    },
  },
};
</script>

<style>
</style>